/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export enum ERRORS {
  'generic' = 'generic',
  'notEnabledRoute' = 'not-enabled-route',
  'missingPage' = 'missing-page',
  'unauthorized' = 'unauthorized',
  'sessionExpired' = 'session_expired',
  'idle' = 'idle',
  'invalidProcess' = 'invalid_process',
  'notRegisteredCustomer' = 'not_registered_customer',
  'incompleteCustomer' = 'incomplete_customer',
  'server' = 'server',
  'retreatPosition' = 'retired_position',
  'concludedPosition' = 'concluded_position',
  'restoreForbidden' = 'restore_forbidden',
  'outOfOrder' = 'out_of_order'
}
